import {
  useSiteContext as RealSiteContext,
  SiteConfiguration,
  SiteData,
} from '@ncr-voyix-commerce/react-common-components';
import { createContext, useContext } from 'react';

/**
 * In order to accommodate the site switcher within preview URLs,
 * we need to conditionally use a 'fake' site switcher that doesn't attempt
 * to make provisioning API requests, based on an environment variable
 * which should only be set to true during the CI pipeline.
 */
// eslint-disable-next-line import/no-mutable-exports
let useSiteContext = RealSiteContext;

export const FakeSiteContext = createContext({
  selectedSite: undefined,
  isSiteDialogOpen: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsSiteDialogOpen: () => {},
  userSitesFromCache: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateSelectedSite: (site: SiteData | undefined) => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateSelectedSiteFromId: (siteId: string | undefined) => {},
  isLoading: false,
  isSiteLoading: false,
  currParent: undefined,
  siteConfiguration: {} as SiteConfiguration,
  defaultSiteConfiguration: {} as SiteConfiguration,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateSiteConfiguration: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCurrParent: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  resetPreload: () => {},
});

export const useFakeSiteContext = () => useContext(FakeSiteContext);

if (process.env.REACT_APP_USE_PREVIEW_ORG_SWITCHER === 'true') {
  useSiteContext = useFakeSiteContext;
}

export default useSiteContext;
